import React from "react";

/**
 * Sortable table header. Optional patterns-style active column and sort-direction arrow.
 * onSort(sortKey) is called on click; parent should toggle sortDirection when sortKey === sortBy.
 */
const SortableTh = ({
  label,
  tooltip,
  sortKey,
  sortBy,
  sortDirection,
  onSort,
  align = "left",
  showSortArrow = true,
  activeClassName = "bg-theme-active-nav",
  className = "",
}) => {
  const isActive = sortBy === sortKey;
  const handleClick = () => onSort(sortKey);
  const alignClass =
    align === "right" ? "text-right" : align === "center" ? "text-center" : "text-left";
  return (
    <th
      className={`px-4 py-2 whitespace-nowrap ${alignClass} text-xs font-medium text-theme-text uppercase tracking-wider cursor-pointer select-none transition-colors ${
        isActive ? activeClassName : "hover:bg-theme-main"
      } ${className}`.trim()}
      onClick={handleClick}
      title={tooltip}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {showSortArrow && isActive && sortDirection ? (
          <span className="opacity-80" aria-hidden>
            {sortDirection === "asc" ? "↑" : "↓"}
          </span>
        ) : null}
      </span>
    </th>
  );
};

export default SortableTh;
